import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    title: {
      fontWeight: 'bold',
      fontSize: '15px',
      paddingLeft: '12px',
      margin: '0',
      color: '#05A4D8',
    },
    td: {
      fontSize: '14px',
    },
    required: {
      width: '6px',
      height: '6px',
      background: '#d9534f',
      display: 'inline-block',
      margin: '4px 0 0 4px',
      borderRadius: '3px',
    },
    tableHeader: {
      fontSize: '13px',
      fontWeight: 'bold',
      textAlign: 'left',
      paddingLeft: '1px',
      paddingRight: ' 4px',
    },
    redIcon: {
      color: legacyColors.red,
    },
  };
};
